import { dec, plannedPerDay } from '@siteday/shared';

export interface PlanHelperResult {
  perDay: string | null;
  /** Working days implied when the user edits per day instead (total ÷ per day, rounded up). */
  days: number | null;
}

/** W6 plan helper: planned total + working days → planned per day (shared plannedPerDay, 2 dp). */
export function planHelper(plannedTotal: string, workingDays: string): PlanHelperResult {
  const total = plannedTotal.replace(/,/g, '').trim();
  const days = Number(workingDays);
  if (!/^\d+(\.\d+)?$/.test(total) || !Number.isFinite(days) || days <= 0)
    return { perDay: null, days: null };
  return { perDay: plannedPerDay(total, days), days: Math.round(days) };
}

/** Reverse helper: total ÷ per-day → working days, rounded up. */
export function daysFromPerDay(plannedTotal: string, perDay: string): number | null {
  const total = plannedTotal.replace(/,/g, '').trim();
  const p = perDay.replace(/,/g, '').trim();
  if (!/^\d+(\.\d+)?$/.test(total) || !/^\d+(\.\d+)?$/.test(p) || dec(p).lte(0)) return null;
  return dec(total).div(p).ceil().toNumber();
}
